<template>
    <SelectButton class="maap-select-button"
        v-model="model"
        :options="options"
    />
</template>

<script>
import SelectButton from 'primevue/selectbutton';
export default {
    name: "MaapSwitchPanel",
    components: {
        SelectButton
    },
    props: {
        modelValue: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    },
    computed: {
        model: {
            get() {
                return this.modelValue ? this.options[0] : this.options[1];
            },
            set(value) {
                let result = true;
                if (value === this.options[1]) {
                    result = false;
                }
                this.$emit('update:modelValue', result);
            }
        }
    },
}
</script>

<style lang="scss">
.maap-select-button {
    background: var(--prospace-ui-gray-switch-bg);
    padding: 4px;
    border-radius: 6px;
    display: flex;
    .p-button.p-component {
        padding: 3px 8px;
        font-size: 14px;
        height: 22px;
        color: var(--prospace-text-gray);
        background: transparent;
        border: none !important;
        box-shadow: none !important;
        .p-button-label {
            white-space: nowrap;
        }
        &.p-highlight {
            color: var(--prospace-text-main);
            background: var(--prospace-ui-bg);
        }
    }
}
</style>